import { render, staticRenderFns } from "./TicketReviewsDetails.vue?vue&type=template&id=756e0b40&"
import script from "./TicketReviewsDetails.vue?vue&type=script&lang=ts&"
export * from "./TicketReviewsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TicketReviewsDetails.vue?vue&type=style&index=0&id=756e0b40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports